import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CanBlockBackClass;
function CanBlockBack() {
  if (CanBlockBackClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'CanBlockBack');
    CanBlockBackClass = $;
  }
  return CanBlockBackClass;
}
//region block: exports
export {
  CanBlockBack as CanBlockBacknswc7za76703,
};
//endregion

//# sourceMappingURL=CanBlockBack.mjs.map
